"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.check = void 0;
var formatFunctions_1 = require("../formatFunctions");
/**
 * Sprawdza czy tekst jest podanego formatu
 * @param format format tekstu
 * @param value wartośc do weryfikacji
 */
function check(format, value) {
    return (0, formatFunctions_1.checkFormat)(format, value);
}
exports.check = check;
exports.default = check;
//# sourceMappingURL=check.js.map